module.exports = __webpack_public_path__ + "media/styles/images/svg/pencil-blue-ca161a3de7fe0701fad1b709f3fd4ba2.svg";